module.exports = __webpack_public_path__ + "static/media/echo.87de1707.png";